module.exports = __webpack_public_path__ + "media/images/favicon-0df8932556f32b706233064854ed337c.ico";